import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { openCommonPageModal } from "../redux/action/utilActions";
import ReactGA from "react-ga";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
    width: "100vw",
    backgroundColor: "black",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",

    overflow: "hidden",
  },
  img: {
    height: "50vh",
    objectFit: "contain",
    [theme.breakpoints.down("md")]: {
      height: "50vh",
    },
  },
  egramBtn: {
    marginTop: theme.spacing(2),
  },
}));

const Comingsoon = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  ReactGA.pageview(`notfound`);

  return (
    <div className={classes.root}>
      <img src="/images/logo/logo.png" className={classes.img} />

      <Button
        color="primary"
        variant="contained"
        className={classes.egramBtn}
        onClick={() => window.open("https://egrampanchayat.in/", "_self")}
      >
        E-Gram Panchayat
      </Button>
    </div>
  );
};
export default Comingsoon;
